var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BX_AEComposition_dahuanghuascale"},[_c('div',{staticClass:"BX_dahuanghuascale BX_dahuanghuascale BX_dahuanghuascale",style:({backgroundImage: 'url('+_vm.mode[0]+')'})})])}
var staticRenderFns = []

export { render, staticRenderFns }